export default __webpack_public_path__ + "static/media/add-image-icon.2ed0134d.svg";